module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/part9-zhong.16fd4fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/part9-zhong.jpg
// module id = SIjJ
// module chunks = 1